module.exports = __webpack_public_path__ + "static/media/banner-sale.c30b4e5e.png";